import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_JOB_PRODUCTS_PATH,
  GetJobProductsErrorDto,
  GetJobProductsRequestQueryParams,
  GetJobProductsSuccessDto,
} from '@/api/rest/resources/types/jobProducts';

type SuccessDto = GetJobProductsSuccessDto;
type ErrorDto = GetJobProductsErrorDto;
type QueryParams = GetJobProductsRequestQueryParams;

export const JOB_PRODUCTS_QUERY_KEY = 'job-products';

export const useJobProducts = (queryParams?: QueryParams) => {
  const queryFn = async () => {
    return getRequest<SuccessDto, undefined, QueryParams>(GET_JOB_PRODUCTS_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: [JOB_PRODUCTS_QUERY_KEY, queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
